// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery';



//Quantity Spinner
document.addEventListener("DOMContentLoaded", event => {

	var $siteSearch = $('.product-search-field');
	
	$siteSearch.removeAttr("disabled");
	$siteSearch.on('focus', event => {
		event.currentTarget.select();

	});
/* 
	$(document).on('click', event => {
		if($siteSearch.hasClass('open')) {
			$siteSearch.removeClass('open');
		}
	}) */
	// console.log($siteSearch);

	$('.Spinner-increment').on('click', function(){
		var $input = $(this).closest('.Spinner').prev('input[type="number"]');
		$input.val( parseInt($input.val()) + 1 );
		$input.trigger('change');
	});
	$('.Spinner-decrement').on('click', function(){
		var $input = $(this).closest('.Spinner').prev('input[type="number"]');
		$input.val( $input.val() == 0 ? 0 :  parseInt($input.val()) - 1 );
		$input.trigger('change');
	});

	$('#billing_state_field, #shipping_state_field').each((index, element) => {
		// console.log(index, element, this);
		// console.log(typeof element);
		if(element) {
			let $select = $(element).find('select');
			// console.log($select);
			// $('<div class="select"></div>').insertBefore($select);
			// $('</div>').insertAfter($select);

			$select.wrap('<div class="select"></div>');
		}
	});

	var $hamburger = $('.hamburger');
	var $nav;
	var $mobileSubNav;

	$hamburger.click(hamburgerClick);

	var mql = window.matchMedia('(max-width: 768px)');

	function screenTest(e) {
		// console.log('screenTest');
		// console.log(e);
		if (e.matches) {
			/* the viewport is 768 pixels wide or less */
			
			if($mobileSubNav == undefined) {

				if($('.SiteNav-item').hasClass('is-active')) {
					$('.SiteNav-item').removeClass('is-active')
				}

				$mobileSubNav = $( ".SiteSubNavContainer" ).clone().appendTo( ".BrandsMobile" );
				$mobileSubNav.addClass('BrandsMobile-menu');

				$('.SiteNav-arrow').unbind('click');
				$('.SiteNav-arrow').click(event => {

					$('.SiteNav-arrow').toggleClass('is-active');
					$('.BrandsMobile').toggleClass('is-active');
					$('.BrandsMobile-menu .SiteSubNav').toggleClass('is-active');
					// $('.SiteNav-item BrandsMobile ').toggle('is-active');
				});

			}
			
		} else {
			/* the viewport is more than than 768 pixels wide */
			
			if($('.SiteSubNavContainer .SiteSubNav').hasClass('is-active')) {
				$('.SiteSubNavContainer .SiteSubNav').removeClass('is-active');
				$('.SiteNav-arrow').removeClass('is-active');
			}
			
			$('.SiteNav-arrow').unbind('click');
			
			if($mobileSubNav != undefined) {
				$mobileSubNav.remove();
				$mobileSubNav = undefined;
			}

			$('.SiteNav-arrow').on('click', event => {
				event.preventDefault();

				event.currentTarget.classList.toggle('is-active');
				event.currentTarget.parentElement.classList.toggle('is-active');

				$('.SiteSubNav').toggleClass('is-active');
			});

		}
	}

	$nav = $('.SiteNav');

	function hamburgerClick(event) {
		// console.log(event);

		$hamburger.toggleClass('is-active');

		if($hamburger.hasClass('is-active')) {
			$nav.addClass('is-active');
		} else {
			$nav.removeClass('is-active');
			// $('.SiteNav-arrow').removeClass('is-active');
			$('.BrandsMobile').removeClass('is-active');
			$('.BrandsMobile-menu .SiteSubNav').removeClass('is-active');
		}
		
	}

	mql.addListener(screenTest);

	screenTest(mql);

});